import { devtools } from 'zustand/middleware';

import { create } from '@app/store/zustand/helpers/create';

interface TempSheetState {
    showOfferSheet: boolean;
}

interface TempSheetStore extends TempSheetState {
    setShowOfferSheet: (show?: boolean) => void;
}

const initialState: TempSheetState = {
    showOfferSheet: false,
};

export const STORE_KEY_TEMP_SHEET = 'temp-sheet-store';

export const useTempSheetStore = create<TempSheetStore>()(
    devtools(
        (set) => ({
            ...initialState,
            setShowOfferSheet: (show = false) => set({ showOfferSheet: show }),
        }),
        { name: STORE_KEY_TEMP_SHEET },
    ),
);
